// PortfolioHeaderTable.js
import React from "react";
import ColGroupHeader from "@portfolio/PFGridComponents/ColGroupHeader";
import CustomArrowIcon from "@portfolio/gridcomponents/components/CustomArrowIcon";

const PortfolioHeaderTable = ({ sortConfig, handleSortClick }) => {
    const columns = [
        { label: "Stocks", key: "symbol", alignLeft: true },
        { label: "Today's Gain%", key: "todayGainPercentage", subLabel: "Gain Amt", subKey: "todayGain" },
        { label: "Overall Gain%", key: "overallGainPercentage", subLabel: "Gain Amt", subKey: "overallGain" },
        null,
        { label: "Current Value", key: "currentValue", className: "last-thead-th" },
        { label: "Quantity", key: "netQuantity", subLabel: "Avg Price", subKey: "weightedAvgPrice" },
        { label: "Invested", key: "amountInvested" },
        { label: "Price", key: "currentPrice", arrowBefore: true },
    ];

    return (
        <div className="pf-header-table-container">
            <table className="pf-header-table" cellPadding="5" cellSpacing="0">
                <ColGroupHeader />
                <thead>
                <tr>
                    {columns.flatMap((column, index) => {
                        if (!column) return [<th key={`empty-${index}`}></th>];
                        const { label, key, subLabel, subKey, className, arrowBefore } = column;

                        const labelTh = (
                            <th key={`label-${key}`} className={className || ""}>
                                {key && (
                                    <div className="th-label" onClick={() => handleSortClick(key)} style={{ cursor: "pointer" }}>
                                        {label}
                                    </div>
                                )}
                                {subLabel && subKey && (
                                    <div className="th-sublabel" onClick={() => handleSortClick(subKey)} style={{ cursor: "pointer" }}>
                                        {subLabel}
                                    </div>
                                )}
                            </th>
                        );

                        const arrowTh = (
                            <th key={`arrow-${key}`} className={className || ""}>
                                {key && (
                                    <div className={`th-arrow ${sortConfig.key === key ? "active" : ""}`}>
                                        <CustomArrowIcon direction={sortConfig.key === key ? sortConfig.direction : null} className="arrow-placeholder" />
                                    </div>
                                )}
                                {subLabel && subKey && (
                                    <div className={`th-arrow sub ${sortConfig.key === subKey ? "active" : ""}`}>
                                        <CustomArrowIcon direction={sortConfig.key === subKey ? sortConfig.direction : null} className="arrow-placeholder" />
                                    </div>
                                )}
                            </th>
                        );

                        return arrowBefore ? [arrowTh, labelTh] : [labelTh, arrowTh];
                    })}
                </tr>
                </thead>
            </table>
        </div>
    );
};

export default PortfolioHeaderTable;
